import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
};

export const Packs = ({ size = 2 }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2L8 0L10 2L12 0H14V16H12L10 14L8 16L6 14L4 16H2V0H4L6 2ZM4 4V12H12V4H4ZM10.8574 5.14258V10.8574H10.2861C10.2861 9.91065 9.51806 9.14258 8.57129 9.14258H7.42871C6.48194 9.14258 5.71387 9.91065 5.71387 10.8574H5.14258V5.14258H10.8574ZM8 5.71387C7.21111 5.71387 6.57144 6.35373 6.57129 7.14258C6.57129 7.93156 7.21102 8.57129 8 8.57129C8.78898 8.57129 9.42871 7.93156 9.42871 7.14258C9.42856 6.35373 8.78889 5.71387 8 5.71387Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </svg>
  );
};
